export const kebabCase = (inputString: string, ampersandToAnd = false) => {
  let s = String(inputString);

  // Optionally convert ampersands to the word "and"
  if (ampersandToAnd) {
    // Replace any ampersand (including surrounded by spaces) with a single space-and-space
    // e.g. "AT&T" -> "AT and T", "A & B" -> "A and B"
    s = s.replace(/&+/g, ' and ');
  }

  return s
    .toLowerCase() // Convert the entire string to lowercase
    .replace(/[^a-z0-9]+/g, '-') // Replace all non-alphanumeric characters with hyphens
    .replace(/^-+|-+$/g, '') // Remove any leading or trailing hyphens
    .replace(/-+/g, '-'); // Replace consecutive hyphens with a single hyphen
};
